module.exports = __webpack_public_path__ + "img/attaching_doorbell.51d2e031.png";